const FLAG = '----------'
export default {
  data() {
    return {
      openAll: false
    }
  },
  methods: {
    toggleOpen() {
      this.openAll = !this.openAll
      this.resetTableHeight()
    },
    resetTableHeight() {
      this.$nextTick(() => {
        this.initTableHeight && this.initTableHeight()
      })
    },
    getQueryCriteria() {
      const arrayList = ['Select', 'Checkbox', 'Radio']
      const queryCriteria = []
      Object.keys(this.selectParam.queryCriteria).forEach(key => {
        const item = this.selectParam.queryCriteria[key]
        const fieldValue = Array.isArray(item.fieldValue) ? item.fieldValue.join(',') : item.fieldValue
        if (item.fieldOperator === 'NULL') {
          queryCriteria.push({
            fieldKey: key,
            fieldOperator: 'EQ',
            fieldValue: arrayList.includes(item.type) ? [] : ''
          })
        } else if (fieldValue || fieldValue === false || fieldValue === 0) {
          queryCriteria.push({
            fieldKey: key.replace(FLAG, ''),
            fieldOperator: item.fieldOperator,
            fieldValue
          })
        }
      })
      return queryCriteria
    }
  }
}
